import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

export const Type = ['default', 'bold', 'small', 'requested', 'denied'] as const;

const labelProps = {
  type: String,
};

export type LabelProps = {
  type: typeof Type[number];
};

const modifiers = {
  default: {
    color: theme.colors.gray5,
    fontSize: theme.font.sizes.p1,
    fontWeight: theme.font.regular,
    lineHeight: theme.font.lineHeights.p1,
  },
  bold: {
    color: theme.colors.gray6,
    fontSize: theme.font.sizes.p1,
    fontWeight: theme.font.bold,
    lineHeight: theme.font.lineHeights.p1,
  },
  small: {
    color: theme.colors.gray5,
    fontSize: theme.font.sizes.p2,
    fontWeight: theme.font.regular,
    lineHeight: theme.font.lineHeights.p2,
  },
  requested: {
    color: theme.colors.supportAlertDark,
    fontSize: theme.font.sizes.p2,
    fontWeight: theme.font.bold,
    lineHeight: theme.font.lineHeights.p2,
  },
  denied: {
    color: theme.colors.supportErrorDark,
    fontSize: theme.font.sizes.p2,
    fontWeight: theme.font.bold,
    lineHeight: theme.font.lineHeights.p2,
  },
};

export const AccessDetails = styled.div`
  background-color: #F9FAF7;
  border-radius: ${theme.border.radius.small};
  display: flex;
  justify-content: space-between;
  height: 112px;
  margin-top: ${theme.spacings.xxlarge};
  padding: 0 ${theme.spacings.xxxlarge};

  & > div {
    align-items: center;
    display: flex;
  }
`;

export const HeadDetails = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Label = styled('p', labelProps)`
  ${({ type }: LabelProps) => css`
    color: ${modifiers[type].color};
    font-size: ${modifiers[type].fontSize};
    font-weight: ${modifiers[type].fontWeight};
    line-height: ${modifiers[type].lineHeight};
  `}
`;

export const Requested = styled.div`
  border-left: 1px solid ${theme.colors.gray3};
  gap: ${theme.spacings.small};
  justify-content: center;
  padding-left: ${theme.spacings.xxxlarge};
  width: 350px;
`;

export const Wrapper = styled.section`
  border: 4px solid transparent;
  :hover {
    border-color: ${theme.colors.secondaryAlpha20};
    box-shadow: ${theme.shadow.lv2};
  }
`;
